import React from 'react';
import _ from 'lodash';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';

const styles = css`
padding: 15px;
@media(min-width: 768px) {
  padding: 45px;
}
  label {
    color: #FFF;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2px;
  }
  h1 {
    color: ${colors.brand2};
    font-size: 42px;
  }
  p {
    color: #000000;
    margin: 0;
  }

  .down-payment-or, .down-payment-percentage {
    display: none;
  }

  input, .input-group-text, .form-control {
    border-radius: 0;
    border: 0;
    outline: 1px solid grey;
    outline-offset: -1px;
  }

  .MortgageCalculator_p {
    color: ${colors.white};
  }
`;

class MortgageCalculator extends React.Component {

  constructor(props) {
    super(props);

    let downPayment = 0;

    if (props.downPaymentAmount) {
      downPayment = props.downPaymentAmount;
    } else {
      downPayment = Math.ceil(props.price * 0.2);
    }

    this.state = {
      price: props.price,
      downPayment,
      interestRate: props.interestRate,
      years: props.years,
    };

    this.handleDownPaymentChange = this.handleDownPaymentChange.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleYearsChange = this.handleYearsChange.bind(this);
    this.handleInterestChange = this.handleInterestChange.bind(this);
  }

  getPayment() {
    const { price, downPayment, years, interestRate } = this.state;

    const c = interestRate / 100 / 12;
    const loan = price - downPayment;
    const months = years * 12;
    const payment = (loan * (c * ((1 + c) ** months))) / (((1 + c) ** months) - 1);

    return payment;
  }

  handleDownPaymentChange(event) {
    const input = _.get(event, 'target.dataset.input');
    let downPayment = 0;

    if (input === 'downPayment') {
      downPayment = parseInt(_.get(event, 'target.value', 0), 10);
    }

    this.setState({
      downPayment,
    });
  }

  handlePriceChange(event) {
    const price = parseInt(_.get(event, 'target.value', 0), 10);

    this.setState({
      price,
    });
  }

  handleYearsChange(event) {
    const years = parseInt(_.get(event, 'target.value', 0), 10);

    this.setState({
      years,
    });
  }

  handleInterestChange(event) {
    const interestRate = parseFloat(_.get(event, 'target.value', 0));

    if (!Number.isNaN(interestRate)) {
      this.setState({
        interestRate,
      });
    } else {
      this.setState({
        interestRate: _.get(event, 'target.value', 0),
      });
    }
  }

  render() {
    const { downPayment, price, interestRate } = this.state;
    return (
      <div className={styles}>
        <div className="form-group price">
          <label htmlFor="price">New Home Price</label>
          <input defaultValue={price} name="price" className="form-control" type="number" onChange={this.handlePriceChange} />
        </div>
        <hr />
        <div className="form-row down-payment">
          <label htmlFor="downPayment">Down Payment</label>
          <div className="input-group">
            <div className="input-group-prepend"><span className="input-group-text">$</span></div>
            <input value={downPayment} name="downPayment" className="form-control" type="number" data-input="downPayment" onChange={this.handleDownPaymentChange} />
          </div>
        </div>
        <hr />
        <div className="form-row interest-rate">
          <label htmlFor="rate">Interest Rate</label>
          <div className="input-group">
            <div className="input-group-prepend"><span className="input-group-text">%</span></div>
            <input value={interestRate} name="rate" className="form-control" type="number" onChange={this.handleInterestChange} />
          </div>
        </div>
        <hr />
        <div className="form-group loan-type">
          <label htmlFor="years">Loan Type</label>
          <select name="years" className="form-control" onChange={this.handleYearsChange}>
            <option value="30">30-year fixed</option>
            <option value="25">25-year fixed</option>
            <option value="20">20-year fixed</option>
            <option value="15">15-year fixed</option>
            <option value="10">10-year fixed</option>
            <option value="5">5-year fixed</option>
            <option value="31">5/1 ARM</option>
          </select>
        </div>
        <hr />
        <p className="text-center MortgageCalculator_p">Estimated Payment:</p>
        <h1 className="text-center">
          {numeral(this.getPayment()).format('$0,0.00')}
          <small>/mo</small>
        </h1>
        <p className="text-center MortgageCalculator_p">
          <small>Principal and Interest only.</small>
        </p>
      </div>
    );
  }
}

MortgageCalculator.propTypes = {
  price: PropTypes.number,
  downPaymentAmount: PropTypes.number,
  interestRate: PropTypes.number,
  years: PropTypes.number,
};
MortgageCalculator.defaultProps = {
  price: 300000,
  downPaymentAmount: undefined,
  interestRate: 3.5,
  years: 30,
};

export default MortgageCalculator;



// WEBPACK FOOTER //
// ./src/components/MortgageCalculatorModal/MortgageCalculator.js